import React from 'react'

const OneOnOne = () => {
  return (
    <div>OneOnOne</div>
  )
}

export default OneOnOne